export default __webpack_public_path__ + "static/media/crown-blue.346088d3.webp";